<div
  class="narrative-editor"
  [class.narrative-editor-readonly]="props.readonly"
  [class.narrative-editor-tall]="props.tall"
  [class.is-valid]="valid"
  [class.is-invalid]="invalid"
>
  <div #editor class="narrative-editor-surface"></div>
</div>
